<template>
<div class="system-announcement" v-show="showList.length">
  <Buttons class="clear" @click="clearAll" v-if="showSaveList.length > 3">{{pageText.clear}}</Buttons>
  <div v-for="(item, idx) in dataList" :key="idx">
    <div class="system-announcement-one" v-if="showList.indexOf(item.id) !== -1">
      <div class="system-announcement-header">
          <span class="icon-style iconfont">&#xe89d;</span>
          <p>{{pageText.notice}}</p>
          <span class="icon-style iconfont close" @click="close(item.id)">&#xe673;</span>
      </div>
      <div class="system-announcement-content">
        <p>{{item.content}}</p>
      </div>
      <div class="system-announcement-footer">
          <Buttons @click="noLongerPrompt(item.id)" size="mini">{{pageText.noTips}}</Buttons>
          <Buttons type="primary" @click="close(item.id)" size="mini">{{pageText.know}}</Buttons>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import orgApi from './api.js'
import response from '../../../utils/response'
import { Buttons } from '../../../index.js'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
export default {
  props: {
    // 公告类型
    type: {
      type: Number,
      default: 0
    },
    // 应用域
    publishScope: {
      type: String,
      default: 'purchaser'
    }
  },
  data () {
    return {
      pageText,
      dataList: [],
      showSaveList: [],
      // 存在session中的数据
      sessionStorageList: [],
      // 存在local中的数据
      localStorageList: [],
      showList: []
    }
  },
  components: {
    Buttons
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化方法
    init () {
      this.localStorageList = (window.localStorage.getItem('system-announcement') && JSON.parse(window.localStorage.getItem('system-announcement'))) || []
      this.sessionStorageList = (window.sessionStorage.getItem('system-announcement') && JSON.parse(window.sessionStorage.getItem('system-announcement'))) || []
      this.queryNotice()
    },
    // 点击关闭
    close (id) {
      if (this.sessionStorageList.indexOf(id) === -1) {
        this.sessionStorageList.push(id)
        window.sessionStorage.setItem('system-announcement', JSON.stringify(this.sessionStorageList))
      }
      this.showList.splice(this.showList.indexOf(id), 1)
    },
    // 清除全部
    clearAll () {
      // 将展示数组中不在sesssion中放入数组中
      this.sessionStorageList = this.sessionStorageList.concat(this.showList)
      window.sessionStorage.setItem('system-announcement', JSON.stringify(this.sessionStorageList))
      this.showList = []
      this.showSaveList = []
    },
    // 获取公告内容
    async queryNotice () {
      let allArray = []
      const api = orgApi.queryNotice
      const promise = this.$http(api.type, api.url, {type: this.type, publishScope: this.publishScope})
      const data = await response(promise)
      if (data.isOk) { 
        this.dataList = data.content || []
        this.dataList.forEach(item => {
          allArray.push(item.id)
          // 不在local和session中才能展示
          if (this.localStorageList.indexOf(item.id) === -1 && this.sessionStorageList.indexOf(item.id) === -1) {
            if (this.showList.indexOf(item.id) === -1) {
              this.showList.push(item.id)
              this.showSaveList.push(item.id)
            }
          }
        })
        // 删除local中已经关闭的数据
        this.localStorageList = this.localStorageList.filter((item) => {
          return allArray.indexOf(item) !== -1
        })
        window.localStorage.setItem('system-announcement', JSON.stringify(this.localStorageList))
      }
    },
    // 点击不再提示
    noLongerPrompt (id) {
      if (this.localStorageList.indexOf(id) === -1) {
        this.localStorageList.push(id)
        window.localStorage.setItem('system-announcement', JSON.stringify(this.localStorageList))
      }
      this.showList.splice(this.showList.indexOf(id), 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.system-announcement {
  position: fixed;
  z-index: 2000;
  right: 0;
  top: 0;
  width: 450px;
  overflow-y: auto;
  max-height: calc(100% - 74px);
  margin-top: 74px;

  .clear {
    margin-bottom: 5px;
  }

  .system-announcement-one {
    color: #242F57;
    font-weight: 300;
    font-size: 12px;
    line-height: 17px;
    padding: 19px 24px 16px 26px;
    width: 420px;
    height: 185px;
    background: #FFFFFF;
    font-family: 'PingFang SC';
    font-style: normal;
    box-shadow: 0px 0px 14px rgba(57, 121, 201, 0.2);
    border-radius: 8px;
    box-sizing: border-box;
    margin: 0px 13px 13px 13px;

   
    .system-announcement-header {
      display: flex;
      padding-bottom: 11px;
      span {
        font-size: 24px;
      }
      .close {
        cursor: pointer;
        font-size: 20px;
        padding: 2px;
        color: #97A0C3;
;
      }
      p {
        flex: 1;
        margin-left: 5px;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
        color: #242F57;
      }
    }
    .system-announcement-content {
      font-weight: 300;
      font-size: 12px;
      line-height: 17px;
      color: #000000;
      padding-left: 30px;
      p {
        width: 345px;
        height: 85px;
        overflow-y: auto;
        word-break: break-word;
      }
    }
    .system-announcement-footer {
        margin-top: 8px;
        float: right;
    }
  }
}
.system-announcement::-webkit-scrollbar {
    width: 5px;
    // height: 10px;
  }
.system-announcement::-webkit-scrollbar-thumb {
  background: #BFC7E0;
  border-radius: 4px;
}
.system-announcement::-webkit-scrollbar-button {
  width: 10px;
  border-radius: 50%;
}

</style>